import React, { useState, useEffect } from 'react';
import Header from '../../dashboard/header';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { FaTools } from 'react-icons/fa';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';

const Modifier_domaine = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');
    const { domaine_id } = location.state || {};
    const navigate = useNavigate();

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Modifier domaine"; // Définit le titre de la page
        }
    }, [user_id]);

    const [formData, setFormData] = useState({
        fr: {
            titre: '',
            description: '',
        },
        en: {
            titre: '',
            description: '',
        },
    });

    const [originalFormData, setOriginalFormData] = useState({});

    useEffect(() => {
        const fetchDomaineData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_HOTE}/domaine-info/${domaine_id}/`);
                if (response.ok) {
                    const data = await response.json();
                    setFormData({
                        fr: {
                            titre: data.fr.titre,
                            description: data.fr.description,
                            ordre: data.fr.ordre_fr,
                        },
                        en: {
                            titre: data.en.titre,
                            description: data.en.description,
                            ordre: data.en.ordre_en,
                        }
                    });
                    setOriginalFormData({
                        fr: { ...data.fr },
                        en: { ...data.en },
                    });
                } else {
                    console.error('Erreur lors de la récupération des données du domaine');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        };

        fetchDomaineData();
    }, [domaine_id]);


    const handleSubmit = async (event) => {
        event.preventDefault();

        // Ajoute cette vérification de validation avant de soumettre les données
        if (!formData.fr.titre || !formData.en.titre) {
            alert('Veuillez remplir tous les champs obligatoires.');
            return;
        }

        const dataToSend = {
            fr: {
                titre: formData.fr.titre,
                description: formData.fr.description,
                ordre: formData.fr.ordre,
            },
            en: {
                titre: formData.en.titre,
                description: formData.en.description,
                ordre: formData.en.ordre,
            },
        };

        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/Modifier-domaine/${domaine_id}/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSend),
            });

            // Vérifie la réponse du serveur
            const data = await response.json();
            console.log('Réponse serveur:', data);

            if (!response.ok) {
                console.error('Erreur:', data);
                alert('Erreur lors de la modification du domaine. Vérifiez les champs.');
            } else {
                console.log('Succès:', data);
                navigate(`/Liste-domaine`);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            alert('Erreur réseau lors de la soumission du formulaire.');
        }
    };



    const handleCancel = () => {
        setFormData(originalFormData); // Réinitialise aux données originales
    };

    const handleChange = (lang, field, value) => {
        setFormData(prevState => ({
            ...prevState,
            [lang]: {
                ...prevState[lang],
                [field]: value
            }
        }));
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');
  
    const verifGroupe = async () => {
      const groupeStored = localStorage.getItem('groupe');
      const accesGroupeStored = localStorage.getItem('accesGroupe');
  
      if (groupeStored && accesGroupeStored) {
        setGroupeId(groupeStored);
        setAccesGroupe(JSON.parse(accesGroupeStored));
      } else {
        try {
          const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
          if (response.status === 200) {
            const data = response.data;
            setGroupeId(data.groupe);
  
            let cleanedAccessArray = [];
            if (Array.isArray(data.acces)) {
              cleanedAccessArray = data.acces.map((item) =>
                item.acces
                  ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                  : []
              ).flat();
  
              setAccesGroupe(cleanedAccessArray);
            }
  
            localStorage.setItem('groupe', data.groupe);
            localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
          }
        } catch (error) {
          // console.error('Erreur lors de la vérification du groupe', error);
        }
      }
    };
  
    useEffect(() => {
      if (user_id) {
        verifGroupe();
      }
    }, [user_id]);
  
    if (!accesGroupe.includes("QCM")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="mr-2"><i className="fa fa-th fa-1x mr-2"></i> Modification du Domaine <b>{formData.fr?.titre}</b></h2>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-domaine`}>Domaines</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Modifier-domaine`}>Modification du Domaine</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-2"></div>
                        <div class="col-lg-8">
                            <form className="m-t" role="form" onSubmit={handleSubmit} encType="multipart/form-data">
                                <div class="ibox " style={{ paddingTop: "30px" }}>
                                    <div class="ibox-title">
                                        <h5>Modifier le domaine</h5>
                                    </div>
                                    <div class="ibox-content">

                                        <div className='row'>
                                            <div class="col-lg-6">

                                                <div class="ibox-title">
                                                    <h5>Version francaise</h5>
                                                </div>
                                                <div class="ibox-content">
                                                    {/* Colonne gauche - Français */}
                                                    <div className="hpanel">
                                                        <div className="panel-body">
                                                            <div className="form-group">
                                                                <label>Titre<span style={{ color: 'red' }}>*</span></label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="titre_fr"
                                                                    value={formData.fr.titre}
                                                                    onChange={(e) => setFormData({ ...formData, fr: { ...formData.fr, titre: e.target.value } })}
                                                                    required
                                                                />
                                                            </div>
                                                            <div className="form-group">
                                                                <label>Description</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    name="description_fr"
                                                                    value={formData.fr.description}
                                                                    onChange={(e) => setFormData({ ...formData, fr: { ...formData.fr, description: e.target.value } })}
                                                                    rows="5"
                                                                />
                                                            </div>
                                                            <div className="form-group">
                                                                <label>Ordre</label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    value={formData.en.ordre}
                                                                    name="ordre_fr"
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="col-lg-6">

                                                <div class="ibox-title">
                                                    <h5>Version anglaise</h5>
                                                </div>
                                                <div class="ibox-content">
                                                    {/* Colonne droite - Anglais */}

                                                    <div className="hpanel">
                                                        <div className="panel-body">
                                                            <div className="form-group">
                                                                <label>Title<span style={{ color: 'red' }}>*</span></label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="titre_en"
                                                                    value={formData.en.titre}
                                                                    onChange={(e) => setFormData({ ...formData, en: { ...formData.en, titre: e.target.value } })}
                                                                    required
                                                                />
                                                            </div>
                                                            <div className="form-group">
                                                                <label>Description</label>
                                                                <textarea
                                                                    className="form-control"
                                                                    name="description_en"
                                                                    value={formData.en.description}
                                                                    onChange={(e) => setFormData({ ...formData, en: { ...formData.en, description: e.target.value } })}
                                                                    rows="5"
                                                                />
                                                            </div>
                                                            <div className="form-group">
                                                                <label>Order</label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    value={formData.en.ordre}
                                                                    name="ordre_en"
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                    <div class="ibox-footer">
                                        <div class="p-2 d-flex justify-content-end align-items-center">
                                            <button type="button" className="btn btn-default mr-2" onClick={handleCancel}>Annuler</button>
                                            <button type="submit" className="btn btn-success">Enregistrer les modifications</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modifier_domaine;
